import React from 'react';

export default function Tabs({
    tabs = [],
    active,
    onChange,
    className = '',
}) {
    return (
        <div className={`border-b border-gray-200 ${className}`}>
            <nav className="flex gap-0 -mb-px">
                {tabs.map((tab) => {
                    const id = typeof tab === 'string' ? tab : tab.id;
                    const label = typeof tab === 'string' ? tab : tab.label;
                    const count = typeof tab === 'object' ? tab.count : undefined;
                    const isActive = active === id;

                    return (
                        <button
                            key={id}
                            onClick={() => onChange(id)}
                            className={`px-4 py-2.5 text-sm font-medium border-b-2 transition-colors whitespace-nowrap ${
                                isActive
                                    ? 'border-gray-900 text-gray-900'
                                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                            }`}
                        >
                            {label}
                            {count !== undefined && (
                                <span className={`ml-1.5 inline-flex items-center justify-center rounded-full px-1.5 py-0.5 text-xs ${
                                    isActive ? 'bg-gray-900 text-white' : 'bg-gray-100 text-gray-600'
                                }`}>
                                    {count}
                                </span>
                            )}
                        </button>
                    );
                })}
            </nav>
        </div>
    );
}
